async function parseJson(response: Response) {
  return response.json().catch(() => null);
}

function extractErrorMessage(payload: any, fallback: string) {
  return payload?.error?.message || payload?.error || fallback;
}

function toQuery(params: Record<string, string | undefined>) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) query.set(key, value);
  });
  const serialized = query.toString();
  return serialized ? `?${serialized}` : "";
}

export async function listCatalogParts(input?: {
  category?: string;
  productLine?: string;
  q?: string;
}) {
  const response = await fetch(`/api/v1/catalog/parts${toQuery(input || {})}`);
  const payload = await parseJson(response);
  if (!response.ok) {
    throw new Error(extractErrorMessage(payload, "Failed to fetch parts"));
  }

  return payload?.data || [];
}

export async function listCatalogRoofAttachments() {
  const response = await fetch("/api/v1/catalog/roof-attachments");
  const payload = await parseJson(response);
  if (!response.ok) {
    throw new Error(extractErrorMessage(payload, "Failed to fetch roof attachments"));
  }

  return payload?.data || [];
}

export async function listCatalogPartTags() {
  const response = await fetch("/api/v1/catalog/part-tags");
  const payload = await parseJson(response);
  if (!response.ok) {
    throw new Error(extractErrorMessage(payload, "Failed to fetch part tags"));
  }

  return payload?.data || [];
}
